import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { ForwardingDto } from 'src/app/models/dns-forwarding.model';
import { GeneralService } from 'src/app/services/general.service';
import { baseUrl } from 'src/environments/environment';

@Component({
  selector: 'app-forwarding',
  templateUrl: './forwarding.page.html',
  styleUrls: ['./forwarding.page.scss'],
})
export class ForwardingPage implements OnInit {


  validator = {

  }

  isLoading = false

  forwardingDetails = {
    status_code: '',
    isSubdomain: true
  }

  domain = ''



  statusCodes = [
    301,
    302
  ]

  redirectRulesetId = ''

  constructor(
    protected modalCtrl: ModalController,
    private http: HttpClient,
    private navParams: NavParams,
    protected generalService: GeneralService
  ) { }

  async ngOnInit() {

    this.isLoading = true
    await new Promise((resolve) => setTimeout(() => {
      resolve(true)
    }, 3000))

    this.isLoading = false

    this.forwardingDetails = JSON.parse(JSON.stringify(this.navParams.get('details')))
    this.forwardingDetails['redirectRulesetId'] = this.navParams.get('redirectRulesetId')
    this.forwardingDetails['isSubdomain'] = this.navParams.get('isSubdomain')
    this.forwardingDetails['id'] = this.navParams.get('id')
    this.domain = this.navParams.get('domain')
  }

  async handleConfirm() {
    let validateResult = await this.generalService.validateInput(this.forwardingDetails, ForwardingDto, [])
    if (validateResult['status'] === 'FAIL') {

      this.generalService.showToast(Object.values(validateResult['result'])[0]['error_message'], 'error', 'top')
      this.validator = validateResult['result']
      return
    }

    this.forwardingDetails = validateResult['correctData']

    this.generalService.pleaseWait({ key: 'Please wait...' }, { key: 'We are saving your forwarding...' })

    let response;

    try {
      if (this.generalService.isNullOrEmpty(this.forwardingDetails['ruleId'])) {
        response = await firstValueFrom(
          this.http.post(`${baseUrl}/domain/create-forwardings`, this.forwardingDetails)
        );
      } else {
        response = await firstValueFrom(
          this.http.put(`${baseUrl}/domain/update-forwardings`, this.forwardingDetails)
        );
      }

      this.generalService.swalClose()

      if (response['status'] === 'SUCCESS') {
        this.generalService.showToast({ key: 'Created successfully' }, 'success', 'top')
        this.modalCtrl.dismiss(true)
      } else {
        this.generalService.showToast(response['message'] || { key: 'DomainFailedToSaveForwarding' }, 'error', 'top')
      }
    } catch (error) {
      this.generalService.swalClose()
      this.generalService.showToast(error?.message || { key: 'DomainFailedToSaveForwarding' }, 'error', 'top')
    }

  }

}
